import React, { useCallback, useEffect } from "react";
import { COLORS } from "../../constant/colors";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import useStyles from "./styles";
import { convertToSlug, imageUrl } from "../../helpers/common";
import { getOrderDetails } from "../../api/orders";
import { useDispatch, useSelector } from "react-redux";
import { showErrorSnackbar, showSuccessSnackbar } from '../../actions/snackbar';
import { updateCartData } from "../../helpers/cart";
import { updateCart } from "../../actions/cart";
import { useNavigate } from "react-router-dom";

export default function OrderDetails({
  openModal,
  handleClose,
  selectedOrder,
  orderAmount,
}) {
  const [currOrder, setCurrOrder] = React.useState(null);
  const [loading, setloading] = React.useState(false);
  const cartData = useSelector((state) => state.cart.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onReorder = useCallback(
    () => {
      const productList = currOrder.map(order => ({ ...order.product, qty: order.quantity }))
      // const newCartData = updateCartData(cartData, productList, 1);

      for (let i = 0; i < productList.length; i++) {
        const product = productList[i];
        const newCartData = updateCartData(cartData, product, 1);
        dispatch(updateCart(newCartData));
      }
      // const newCartData = [...cartData , productList];

      // dispatch(updateCart(newCartData));
      // TODO: fix this later - need to update the cart data 

      dispatch(showSuccessSnackbar("Product added to cart"));
      navigate('/cart');
    },
    [currOrder, cartData, dispatch, navigate]
  );


  useEffect(() => {
    if (selectedOrder && selectedOrder.id) {
      setloading(true);
      getOrderDetails(selectedOrder.order_id)
        .then((res) => {
          setloading(false);
          setCurrOrder(res.data);
          console.log("res.data:: ",res.data);
        })
        .catch((err) => {
          console.log(err);
          if ( err.message.includes("401") ) {
            dispatch(showErrorSnackbar('Unauthorized! Please login again.'));
          } 
          setloading(false);
        })
    }
  }, [selectedOrder, dispatch]);

  const classes = useStyles();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px !important",
    width: "60%",
    height: "90%",
    borderRadius: "10px",
    bgcolor: "background.paper",
    boxShadow: `0px 4px 16px -6px ${COLORS.lightGrey}`,
    transition: "all 0.5s ease-in-out",
    overflow: "overlay !important",
    overflowX: "hidden !important",
    "@media (max-width: 991px)": {
      width: "90%",
      height: "80%",
    },
    "@media (max-width: 550px)": {
      width: "95%",
      height: "75%",
    },
  };

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={openModal}>
        <Box sx={style}>
          <div className={classes.modalHeader}>
            <div className={classes.modalTitle}>
              <h2 className={classes.modalHeading}>Order Details</h2>
              <div className={classes.orderIdBadge}>
                <span className={classes.orderIdLabel}>Order ID</span>
                <span className={classes.orderIdValue}>#{selectedOrder?.order_id}</span>
              </div>
            </div>
            <div onClick={handleClose} className={classes.closeButton}>
              <i className="fa fa-times" />
            </div>
          </div>

          {loading ? (
            <div className={classes.loaderSec}>
              <img
                className={classes.loader}
                src="/images/loader1.gif"
                alt="loading..."
              />
            </div>
          ) : (
            <div className={classes.modalContent}>
              {/* Order Items Section */}
              <div className={classes.itemsSection}>
                <h3 className={classes.sectionTitle}>
                  {currOrder?.length > 1 ? "Order Items" : "Order Item"}
                </h3>
                <div className={classes.itemsList}>
                  {currOrder?.map((item, index) => (
                    <div
                      key={"order-detail-" + index}
                      className={classes.productCard}
                      onClick={() => navigate(`/product/${item?.product?.id}/${convertToSlug(item?.product?.name)}`)}
                    >
                      <div className={classes.productImage}>
                        <img
                          src={imageUrl(
                            item?.product?.main_image,
                            `products/${item?.product?.id}`
                          )}
                          alt="product-img"
                        />
                      </div>
                      <div className={classes.productInfo}>
                        <h4 className={classes.productName}>{item?.product?.name}</h4>
                        <div className={classes.productDetails}>
                          <div className={classes.productSku}>SKU: {item?.product?.sku}</div>
                          <div className={classes.productQuantity}>Qty: {item.quantity}</div>
                        </div>
                        <div className={classes.productPricing}>
                          <div className={classes.priceRow}>
                            <span className={classes.priceLabel}>Rate:</span>
                            <span className={classes.priceValue}>
                              <i className="fa fa-inr"></i> {item.rate}
                            </span>
                          </div>
                          <div className={classes.priceRow}>
                            <span className={classes.priceLabel}>Amount:</span>
                            <span className={classes.priceValue}>
                              <i className="fa fa-inr"></i> {item.amount}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Payment Summary Section */}
              {!loading && currOrder && (
                <div className={classes.paymentSection}>
                  <h3 className={classes.sectionTitle}>Payment Summary</h3>
                  <div className={classes.paymentCard}>
                    <div className={classes.paymentRow}>
                      <span className={classes.paymentLabel}>Subtotal:</span>
                      <span className={classes.paymentValue}>
                        <i className="fa fa-inr"></i> {currOrder[0]?.amount || 0}
                      </span>
                    </div>
                    
                    {currOrder[0]?.discount_amount > 0 && (
                      <div className={classes.paymentRow}>
                        <span className={classes.paymentLabel}>
                          Discount ({currOrder[0]?.discount_percentage}%):
                        </span>
                        <span className={`${classes.paymentValue} ${classes.discount}`}>
                          -<i className="fa fa-inr"></i> {currOrder[0]?.discount_amount}
                        </span>
                      </div>
                    )}
                    
                    {currOrder[0]?.tax_amount > 0 && (
                      <div className={classes.paymentRow}>
                        <span className={classes.paymentLabel}>
                          Tax ({currOrder[0]?.tax_percentage}%):
                        </span>
                        <span className={classes.paymentValue}>
                          <i className="fa fa-inr"></i> {currOrder[0]?.tax_amount}
                        </span>
                      </div>
                    )}
                    
                    <div className={classes.paymentDivider}></div>
                    
                    <div className={`${classes.paymentRow} ${classes.total}`}>
                      <span className={classes.paymentLabel}>Total Amount:</span>
                      <span className={`${classes.paymentValue} ${classes.total}`}>
                        <i className="fa fa-inr"></i> {currOrder[0]?.total_amount || orderAmount}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* Order Actions */}
              {!loading && currOrder && (
                <div className={classes.orderActions}>
                  <button onClick={onReorder} className={classes.reorderButton}>
                    <i className="fa fa-shopping-cart"></i>
                    Reorder Items
                  </button>
                </div>
              )}
            </div>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
